import { useEffect, useState } from "react";
import { Clock, Info } from "lucide-react";

export const QUOTE_LIFECYCLE_NOTE = "Bu teklif talebi toplam 48 saat geçerlidir. İlk 24 saat teklif verilebilir. 24 saatten sonra yeni teklif alınmaz. 48 saat sonunda teklif talebi, teklifler ve teklif içerisindeki mesajlaşmalar sistemden otomatik olarak kaldırılır.";

export function QuoteLifecycleNote({ testid = "quote-lifecycle-note" }) {
  return (
    <div data-testid={testid} className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 flex items-start gap-2.5">
      <Info className="w-4 h-4 text-amber-300 shrink-0 mt-0.5" />
      <p className="text-xs text-amber-200/90 leading-relaxed">{QUOTE_LIFECYCLE_NOTE}</p>
    </div>
  );
}

function fmtRemaining(sec) {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  return `${h} sa ${m} dk`;
}

export function QuoteCountdown({ createdAt, testid = "quote-countdown" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);
  const created = new Date(createdAt).getTime();
  if (!created) return null;
  const remain = Math.max(0, Math.floor((created + 48 * 3600 * 1000 - now) / 1000));
  const offerRemain = Math.max(0, Math.floor((created + 24 * 3600 * 1000 - now) / 1000));
  if (remain <= 0) return null;
  return (
    <div data-testid={testid} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px]">
      <span data-testid={`${testid}-total`} className="flex items-center gap-1 text-amber-300 font-semibold">
        <Clock className="w-3.5 h-3.5" /> Kalan süre: {fmtRemaining(remain)}
      </span>
      <span data-testid={`${testid}-offer`} className={offerRemain > 0 ? "text-slate-400" : "text-red-300 font-semibold"}>
        {offerRemain > 0 ? `Teklif verme: ${fmtRemaining(offerRemain)} kaldı` : "Yeni teklif verme kapandı"}
      </span>
    </div>
  );
}
